import { GroupingState, SortingState } from '@tanstack/react-table';
import { useMemo } from 'react';

import {
  markSectionsByDate,
  MarkSectionsByDateOptions,
  SectionName,
} from '@work4all/utils/lib/mark-sections-by-date';

import { BasicTableColumn, DataType } from '../types';

interface UseDateSectionsProps
  extends Pick<
    MarkSectionsByDateOptions<never, never>,
    'markWithDayNameForPastDaysThisWeek'
  > {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Array<Record<string, any> | null>;
  columns: {
    id?: number | string;
    accessor?: BasicTableColumn['accessor'];
    dataType?: DataType;
  }[];

  sorting: SortingState;
  grouping: GroupingState;
  availableDateSections?: SectionName[];
}

export const useDateSectionsV8 = (props: UseDateSectionsProps) => {
  const {
    data,
    columns,
    sorting,
    grouping,
    availableDateSections,
    markWithDayNameForPastDaysThisWeek,
  } = props;

  return useMemo(() => {
    const sortById = sorting?.[0]?.id;
    const sortColumn = columns.find((column) => {
      const id = column.id ?? (column.accessor as string);
      return id === sortById;
    });
    const isSortedByDate = sortColumn?.dataType === DataType.Date;
    const isGrouped = grouping != null && grouping.length > 0;

    const items =
      data?.map((item) => {
        return item ?? { skeleton: true };
      }) ?? [];

    if (isSortedByDate && !isGrouped) {
      return markSectionsByDate({
        items: data,
        getDate(item) {
          return item?.[sortById];
        },
        mapFn(item, { isSectionStart, sectionLabel }) {
          if (item == null) {
            return { skeleton: true };
          }
          return { ...item, meta: { isSectionStart, sectionLabel } };
        },
        availableDateSections,
        markWithDayNameForPastDaysThisWeek,
      });
    }

    return items;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
};
